// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"379":"55cd7ac6","498":"51999dc5","703":"1284c413"}[chunkId] + ".chunk.js";
};